const FROM_SIZE = 100
const ROW_THRESHOLD = 10
const VIEW_ALL = 'View all'
const MODULE_NAME = 'fulcrum/containers/Project/Search'
const MOUNT = 'fulcrum/containers/Project/Search/MOUNT'
const UNMOUNT = 'fulcrum/containers/Project/Search/UNMOUNT'
const CLEAR = 'fulcrum/containers/Project/Search/'

const ON_APPLY_FILTER = 'fulcrum/containers/Project/Search/ON_APPLY_FILTER'
const ON_SORT_CHANGE = 'fulcrum/containers/Project/Search/ON_SORT_CHANGE'
const ON_MENU_HIDE = 'fulcrum/containers/Project/Search/ON_MENU_HIDE'
const ON_SECTION_RENDER = 'fulcrum/containers/Project/Search/ON_SECTION_RENDER'
const ON_FIELD_FILTER_CHANGE = 'fulcrum/containers/Project/Search/ON_FIELD_FILTER_CHANGE'
const ON_INPUT_FILTER_CHANGE = 'fulcrum/containers/Project/Search/ON_INPUT_FILTER_CHANGE'
const ON_INPUT_CHANGE = 'fulcrum/containers/Project/Search/ON_INPUT_CHANGE'
const ON_SELECT_FILTER = 'fulcrum/containers/Project/Search/ON_SELECT_FILTER'
const ON_REMOVE_FILTER = 'fulcrum/containers/Project/Search/ON_REMOVE_FILTER'
const ON_SUBMIT = 'fulcrum/containers/Project/Search/ON_SUBMIT'
const ON_CLEAR_FILTER = 'fulcrum/containers/Project/Search/ON_CLEAR_FILTER'
const ON_SAVE_CLICK = 'fulcrum/containers/Project/Search/ON_SAVE'
const ON_CANCEL_CLICK = 'fulcrum/containers/Project/Search/ON_CANCEL_CLICK'
const ON_FIELD_BUTTON_CLICK = 'fulcrum/containers/Project/Search/ON_FIELD_BUTTON_CLICK'
const ON_SELECT_FIELD = 'fulcrum/containers/Project/Search/ON_SELECT_FIELD'
const ON_REMOVE_FIELD = 'fulcrum/containers/Project/Search/ON_REMOVE_FIELD'
const ON_DIALOG_CLEAR = 'fulcrum/containers/Project/Search/ON_DIALOG_CLEAR'
const ON_SELECT_PUBLIC_FILTER = 'fulcrum/containers/Project/Search/ON_SELECT_PUBLIC_FILTER'
const ON_REMOVE_PUBLIC_FILTER = 'fulcrum/containers/Project/Search/ON_REMOVE_PUBLIC_FILTER'
const ON_PINNED_CLICK = 'fulcrum/containers/Project/Search/ON_PINNED_CLICK'
const ON_ROW_SIZE_CHANGE = 'fulcrum/containers/Project/Search/ON_ROW_SIZE_CHANGE'
const ON_HEADER_CLICK = 'fulcrum/containers/Project/Search/ON_HEADER_CLICK'
const ON_COLUMN_REORDER = 'fulcrum/containers/Project/Search/ON_COLUMN_REORDER'
const ON_HEADER_FILTER_CHANGE = 'fulcrum/containers/Project/Search/ON_HEADER_FILTER_CHANGE'
const ON_HEADER_CLEAR_FILTER = 'fulcrum/containers/Project/Search/ON_HEADER_CLEAR_FILTER'
const ON_HEADER_FILTER_REMOVE = 'fulcrum/containers/Project/Search/ON_HEADER_FILTER_REMOVE'
const ON_CLEAR_ALL = 'fulcrum/containers/Project/Search/ON_CLEAR_ALL'
const ON_INPUT_HEADER_VALUE_CHANGE = 'fulcrum/containers/Project/Search/ON_INPUT_HEADER_VALUE_CHANGE'

const ON_SELECT_SEARCH_FILTER = 'fulcrum/containers/Project/Search/ON_SELECT_SEARCH_FILTER'
const ON_REMOVE_SEARCH_FILTER = 'fulcrum/containers/Project/Search/ON_REMOVE_SEARCH_FILTER'

const CLEAR_HEADER_FILTERS = 'fulcrum/containers/Project/Search/CLEAR_HEADER_FILTERS'
const CLEAR_FILTERS = 'fulcrum/containers/Project/Search/CLEAR_FILTERS'
const CLEAR_CUSTOM_COL_ORDER = 'fulcrum/containers/Project/Search/CLEAR_CUSTOM_COL_ORDER'
const REMOVE_FILTERS = 'fulcrum/containers/Project/Search/REMOVE_FILTERS'

const UPDATE_SORT_INDEX = 'fulcrum/containers/Project/Search/UPDATE_SORT_INDEX'
const UPDATE_SORT_BY = 'fulcrum/containers/Project/Search/UPDATE_SORT_BY'
const UPDATE_SORT_TYPE = 'fulcrum/containers/Project/Search/UPDATE_SORT_TYPE'
const UPDATE_HEADER_FILTER = 'fulcrum/containers/Project/Search/UPDATE_HEADER_FILTER'
const REMOVE_HEADER_FILTER = 'fulcrum/containers/Project/Search/REMOVE_HEADER_FILTER'
const UPDATE_CURRENT_INDEX = 'fulcrum/containers/Project/Search/UPDATE_CURRENT_INDEX'
const UPDATE_ACTIVE = 'fulcrum/containers/Project/Search/UPDATE_ACTIVE'
const UPDATE_SCROLL = 'fulcrum/containers/Project/Search/UPDATE_SCROLL'
const UPDATE_INPUT_FILTER_VALUE = 'fulcrum/containers/Project/Search/UPDATE_INPUT_FILTER_VALUE'
const UPDATE_INPUT_VALUE = 'fulcrum/containers/Project/Search/UPDATE_INPUT_VALUE'
const UPDATE_FILTERS = 'fulcrum/containers/Project/Search/UPDATE_FILTERS'
const INITIALIZE_FILTERS = 'fulcrum/containers/Project/Search/INITIALIZE_FILTERS'
const INITIALIZE_HEADER_FILTERS = 'fulcrum/containers/Project/Search/INITIALIZE_HEADER_FILTERS'
const UPDATE_FROM = 'fulcrum/containers/Project/Search/UPDATE_FROM'
const UPDATE_SIZE = 'fulcrum/containers/Project/Search/UPDATE_SIZE'
const UPDATE_TOTAL = 'fulcrum/containers/Project/Search/UPDATE_TOTAL'
const UPDATE_PINNED = 'fulcrum/containers/Project/Search/UPDATE_PINNED'
const UPDATE_ROW_SIZE = 'fulcrum/containers/Project/Search/UPDATE_ROW_SIZE'
const UPDATE_MAX_ROW_SIZE = 'fulcrum/containers/Project/Search/UPDATE_MAX_ROW_SIZE'
const UPDATE_MENU_ACTIVE = 'fulcrum/containers/Project/Search/UPDATE_MENU_ACTIVE'
const UPDATE_INPUT_HEADER_LIST = 'fulcrum/containers/Project/Search/UPDATE_INPUT_HEADER_LIST'
const UPDATE_LIST_ORDER = 'fulcrum/containers/Project/Search/UPDATE_LIST_ORDER'
const UPDATE_CUSTOM_COL_ORDER = 'fulcrum/containers/Project/Search/UPDATE_CUSTOM_COL_ORDER'

// Fetch Filters
const FETCH_PROJECT_FILTERS = 'fulcrum/containers/Project/Search/FETCH_PROJECT_FILTERS'
const FETCH_PROJECT_FILTERS_START = 'fulcrum/containers/Project/Search/FETCH_PROJECT_FILTERS_START'
const FETCH_PROJECT_FILTERS_SUCCESS = 'fulcrum/containers/Project/Search/FETCH_PROJECT_FILTERS_SUCCESS'
const FETCH_PROJECT_FILTERS_ERROR = 'fulcrum/containers/Project/Search/FETCH_PROJECT_FILTERS_ERROR'

// Fetch List
const FETCH_PROJECT_LIST = 'fulcrum/containers/Project/Search/FETCH_PROJECT_LIST'
const FETCH_PROJECT_LIST_START = 'fulcrum/containers/Project/Search/FETCH_PROJECT_LIST_START'
const FETCH_PROJECT_LIST_SUCCESS = 'fulcrum/containers/Project/Search/FETCH_PROJECT_LIST_SUCCESS'
const FETCH_PROJECT_LIST_ERROR = 'fulcrum/containers/Project/Search/FETCH_PROJECT_LIST_ERROR'
const POST_FETCH_PROJECT_LIST_SUCCESS = 'fulcrum/containers/Project/Search/POST_FETCH_PROJECT_LIST_SUCCESS'

const UPDATE_FIELD_FILTER_VALUE = 'fulcrum/containers/Project/Search/UPDATE_FIELD_FILTER_VALUE'
const CLEAR_FIELD_FILTERS = 'fulcrum/containers/Project/Search/CLEAR_FIELD_FILTERS'
const CLEAR_QUICK_FILTERS = 'fulcrum/containers/Project/Search/CLEAR_QUICK_FILTERS'

const UPDATE_FIELD_FILTERS = 'fulcrum/containers/Project/Search/UPDATE_FIELD_FILTERS'
const CLEAR_TEMP_FIELD_FILTERS = 'fulcrum/containers/Project/Search/CLEAR_TEMP_FIELD_FILTERS'
const UPDATE_TEMP_FIELD_FILTERS = 'fulcrum/containers/Project/Search/UPDATE_TEMP_FIELD_FILTERS'
const REMOVE_TEMP_FIELD_FILTERS = 'fulcrum/containers/Project/Search/REMOVE_TEMP_FIELD_FILTERS'
const COPY_TEMP_FIELD_FILTERS = 'fulcrum/containers/Project/Search/COPY_TEMP_FIELD_FILTERS'

const COPY_DISPLAY_FILTERS = 'fulcrum/containers/Project/Search/COPY_DISPLAY_FILTERS'
const UPDATE_DISPLAY_FILTER = 'fulcrum/containers/Project/Search/UPDATE_DISPLAY_FILTER'
const REMOVE_DISPLAY_FILTER = 'fulcrum/containers/Project/Search/REMOVE_DISPLAY_FILTER'
const CLEAR_DISPLAY_FILTERS = 'fulcrum/containers/Project/Search/CLEAR_DISPLAY_FILTERS'
const UPDATE_SELECTED_SEARCH_FILTERS = 'fulcrum/containers/Project/Search/UPDATE_SELECTED_SEARCH_FILTERS'

const UPDATE_QUICK_FILTER = 'fulcrum/containers/Project/Search/UPDATE_QUICK_FILTER'
const REMOVE_QUICK_FILTER = 'fulcrum/containers/Project/Search/REMOVE_QUICK_FILTER'
const COPY_QUICK_FILTERS = 'fulcrum/containers/Project/Search/COPY_QUICK_FILTERS'
const CLEAR_TEMP_QUICK_FILTERS = 'fulcrum/containers/Project/Search/CLEAR_TEMP_QUICK_FILTERS'
const UPDATE_TEMP_QUICK_FILTERS = 'fulcrum/containers/Project/Search/UPDATE_TEMP_QUICK_FILTERS'
const REMOVE_TEMP_QUICK_FILTERS = 'fulcrum/containers/Project/Search/REMOVE_TEMP_QUICK_FILTERS'
const COPY_TEMP_QUICK_FILTERS = 'fulcrum/containers/Project/Search/COPY_TEMP_QUICK_FILTERS'
const UPDATE_SEARCH_FILTERS_SOURCE = 'fulcrum/containers/Project/Search/UPDATE_SEARCH_FILTERS_SOURCE'
const CLEAR_SEARCH_FILTERS = 'fulcrum/containers/Project/Search/CLEAR_SEARCH_FILTERS'

const DELETE_CUSTOM_VIEW = 'fulcrum/containers/Project/Search/DELETE_CUSTOM_VIEW'
const EDIT_CUSTOM_VIEW = 'fulcrum/containers/Project/Search/EDIT_CUSTOM_VIEW'

const ADD_CUSTOM_VIEW = 'fulcrum/containers/Project/Search/ADD_CUSTOM_VIEW'
const REMOVE_CUSTOM_VIEW = 'fulcrum/containers/Project/Search/REMOVE_CUSTOM_VIEW'
const ENABLE_CUSTOM_VIEW = 'fulcrum/containers/Project/Search/ENABLE_CUSTOM_VIEW'
const DISABLE_CUSTOM_VIEW = 'fulcrum/containers/Project/Search/DISABLE_CUSTOM_VIEW'

const UPDATE_SEARCH_FILTERS = 'fulcrum/containers/Project/Search/UPDATE_SEARCH_FILTERS'
const ADD_TO_SEARCH_FILTERS = 'fulcrum/containers/Project/Search/ADD_TO_SEARCH_FILTERS'

const ON_SELECT_PRODUCT_FILTER = 'fulcrum/containers/Project/Search/ON_SELECT_PRODUCT_FILTER'

const UPDATE_PRODUCT_HIERARCHY_SOURCE = 'fulcrum/containers/Project/Search/UPDATE_PRODUCT_HIERARCHY_SOURCE'
const UPDATE_PRODUCT_HIERARCHY_FILTER = 'fulcrum/containers/Project/Search/UPDATE_PRODUCT_HIERARCHY_FILTER'
const AUTO_UPDATE_PRODUCT_HIERARCHY_SOURCE = 'fulcrum/containers/Project/Search/AUTO_UPDATE_PRODUCT_HIERARCHY_SOURCE'
const TOGGLE_COLLAPSE = 'fulcrum/containers/Project/Search/TOGGLE_COLLAPSE'

const RESET_PRODUCT_HIERARCHY_FILTER = 'fulcrum/containers/Project/Search/RESET_PRODUCT_HIERARCHY_FILTER'

const SAVE_VIEW = 'fulcrum/containers/Project/Search/SAVE_VIEW'
const CLEAR_VIEW_LABEL = 'fulcrum/containers/Project/Search/CLEAR_VIEW_LABEL'

const SET_DEFAULT_VIEW = 'fulcrum/containers/Project/Search/SET_DEFAULT_VIEW'
const UPDATE_PUBLIC_CUSTOM_VIEWS = 'fulcrum/containers/Project/Search/UPDATE_PUBLIC_CUSTOM_VIEWS'
const UPDATE_CUSTOM_VIEW = 'fulcrum/containers/Project/Search/UPDATE_CUSTOM_VIEW'
const UPDATE_VIEW_NAME = 'fulcrum/containers/Project/Search/UPDATE_VIEW_NAME'
const TOGGLE_PUBLIC_VIEW = 'fulcrum/containers/Project/Search/TOGGLE_PUBLIC_VIEW'

const UPDATE_TEMP_CUSTOM_VIEW = 'fulcrum/containers/Project/Search/UPDATE_TEMP_CUSTOM_VIEW'
const UPDATE_TEMP_SEARCH_FILTERS = 'fulcrum/containers/Project/Search/UPDATE_TEMP_SEARCH_FILTERS'
const UPDATE_TEMP_PRODUCT_FILTERS = 'fulcrum/containers/Project/Search/UPDATE_TEMP_PRODUCT_FILTERS'
const UPDATE_TEMP_SELECTED_PRODUCT_FILTERS = 'fulcrum/containers/Project/Search/UPDATE_TEMP_SELECTED_PRODUCT_FILTERS'
const UPDATE_TEMP_SELECTED_SEARCH_FILTERS = 'fulcrum/containers/Project/Search/UPDATE_TEMP_SELECTED_SEARCH_FILTERS'


const SELECT_TEMP_SEARCH_FILTER = 'fulcrum/containers/Project/Search/SELECT_TEMP_SEARCH_FILTER'
const REMOVE_TEMP_SEARCH_FILTER = 'fulcrum/containers/Project/Search/REMOVE_TEMP_SEARCH_FILTER'
const SELECT_TEMP_PRODUCT_FILTER = 'fulcrum/containers/Project/Search/SELECT_TEMP_PRODUCT_FILTER'
const REMOVE_TEMP_PRODUCT_FILTER = 'fulcrum/containers/Project/Search/REMOVE_TEMP_PRODUCT_FILTER'

const TOGGLE_SEARCH_SECTION_COLLAPSE = 'fulcrum/containers/Project/Search/TOGGLE_SEARCH_SECTION_COLLAPSE'
const CLEAR_SEARCH_SECTION_COLLAPSES = 'fulcrum/containers/Project/Search/CLEAR_SEARCH_SECTION_COLLAPSES'
const DESELECT_ALL_SEARCH_FILTERS = 'fulcrum/containers/Project/Search/DESELECT_ALL_SEARCH_FILTERS'
const SELECT_ALL_SEARCH_FILTERS = 'fulcrum/containers/Project/Search/SELECT_ALL_SEARCH_FILTERS'

const CLEAR_SEARCH_FILTERS_UI = 'fulcrum/containers/Project/Search/CLEAR_SEARCH_FILTERS_UI'
const COPY_HEADER_FILTERS = 'fulcrum/containers/Project/Search/COPY_HEADER_FILTERS'

const EXPAND_ALL_SEARCH_FILTERS = 'fulcrum/containers/Project/Search/EXPAND_ALL_SEARCH_FILTERS'
const COLLAPSE_ALL_SEARCH_FILTERS = 'fulcrum/containers/Project/Search/COLLAPSE_ALL_SEARCH_FILTERS'
const SELECT_ALL_SEARCH_SECTION = 'fulcrum/containers/Project/Search/SELECT_ALL_SEARCH_SECTION'

const COPY_PRODUCT_HIERARCHY = 'fulcrum/containers/Project/Search/COPY_PRODUCT_HIERARCHY'

export const defaultSelectedSearchFields = [
  'id',
  'project_name',
  'product_sku',
  'product_brand',
  'partner_site',
  'partner',
  'odm',
  'target_application',
  'created_at',
  'created_by',
  'lifecycle',
  'project_health',
  'customer_class',
  'product_class',
  'ae_resource_level',
  'ae_regions',
  'nvqual_status',
  'nvqual_nvbugs',
  'ae_notes',
  'project_type',
  'project_waiver_status',
  'project_waiver_details',
  'project_restricted',
  'form_factor',
  // nested
  'features',
  'project_ssid',
  'project_ssid.value',
  'project_svid.value',
  'schedule.evt_start',
  'schedule.dvt_start',
  'schedule.pvt_start',
  'schedule.pilot_start',
  'schedule.mp_start',
  'schedule.sbios_lock',
  'schedule.whql_rc',
  'schedule.whql_production',
  'schedule.a_sample',
  'schedule.b_sample',
  'schedule.c_sample',
  'schedule.d_sample',
  'schedule.sop_start',
  'support_team.customer_program_manager',
  'support_team.applications_engineering_manager',
  'support_team.account_applications_engineer',
  'support_team.field_applications_engineer',
  'support_team.applications_engineering_director',
  'support_team.product_applications_engineer',
  'support_team.product_manager',
  'support_team.customer_program_director',
  'support_team.observer',
  'project_features.ms_hybrid_support',
  'project_features.discrete_mode',
  'project_features.aspm_support',
  'project_features.gc6_support',
  'project_features.gsync_dd_support',
  'project_features.gsync_nvsr_support',
  'project_features.gsync_hdr_support',
  'project_features.vapor_chamber',
  'project_features.heat_pipes',
  'project_features.2_way_sli',
  'project_features.3_way_sli',
  'project_features.thermal_led',
  'project_features.rtd3',
  'project_features.zero_power',
  'project_features.power_brake_b30',
  'project_features.smbpbi',
  'project_features.smbpbi_over_pcie',
  'project_features.programmable_edp_peak',
  'project_features.sr_iov',
  'project_features.rtx_studio',
  'project_features.dynamic_display_switching',
  'project_features.pcie_cable',
  'project_features.system_wake_on_wifi_support',
  'project_features.whispermode',
  'project_features.fanstop',
  'project_features.arm_uefi',
  'project_features.nvlink_bridge_support',
  'project_features.nvidia_certified',
  'project_features.virtual_gpu_certified',
  'project_features.voltage_monitoring',
  'project_features.in_system_test',
  'project_features.multi_instance_gpu',
  'project_features.video_decode',
  'project_features.optical_flow_accelerator',
  'project_features.nvaie_compatible',
  'project_features.workstation',
  'project_features.mobile_workstation',
  'project_features.datacenter',
  'project_features.enterprise_edge',
  'project_features.industrial_edge',
  'project_features.high_density_virtualization',
  'project_features.ngc_ready',
]


const rowSize = [
  100,
  500,
  1000,
  5000
]

const listSortOrder = [
  'id',
  'project_name',
  'product_segment',
  'product_line',
  'product_family',
  'product_platform',
  'product_sku',
  'product_brand',
  'partner_site',
  'project_description',
  'project_hierarchy',
  'gam_approval_id',
  'associated_projects',
  'partner',
  'odm',
  'target_application',
  'system_model_name',
  'system_form_factor',
  'system_rack_unit',
  'system_jbog',
  'system_cpu_count',
  'system_gpu_count',
  'system_nvlink_topology',
  'system_nvlink_speed',
  'system_notes',
  'cpu_core_count',
  'cpu_frequency',
  'gpu_frequency',
  'gpu_count_per_baseboard',
  'created_at',
  'created_by',
  'lifecycle',
  'project_health',
  'customer_class',
  'product_class',
  'ae_resource_level',
  'ae_regions',
  'greenlight_status',
  'nvqual_status',
  'nvqual_nvbugs',
  'ae_notes',
  'project_type',
  'external_source',
  'project_waiver_status',
  'project_waiver_details',
  'project_restricted',
  'form_factor',
  'system_form_factor',
  'battery_size',
  'battery_tgp',
  'battery_discharge_rate',
  'battery_ac_adapter_wattage',
  'battery_ac_adapter_voltage',
  'battery_ac_adapter_size',
  'advanced_optimus',
  'display_ms_hybrid_mode',
  'display_discrete_mode_no_edp_mux',
  'display_edp_mux_part_number',
  'chassis_width',
  'chassis_length',
  'chassis_height',
  'max_vin_batt',
  'min_vin_batt',
  'pressure_on_lid',
  'max_pq',
  'max_pq_certification_participation',
  'max_pq_platform_power_aware_gpu_boost',
  'max_pq_configurable_tgp_mode',
  'max_pq_configurable_tgp_value',
  'shipping_tgp',
  'max_tgp',
  'system_cpu_tdp',
  'system_cpu_count',
  'system_memory',
  'system_pcie_speed',
  'system_pcie_width',
  'system_jbog',
  'system_model_name',
  'system_notes',
  'system_power_supply_config',
  'system_memory_size',
  'system_pcie_max_depth',
  'system_cpu_pcie_link',
  'os_version',
  'gpu_driver_version',

  'contract_start',
  'contract_end',
  'reference_design',
  'nvidia_soc_product',
  'configuration_use_case',
  'cpu_speed',
  'gpu_speed',
  'pva_speed',
  'dla_speed',
  'low_power_mode_suspend_trigger',
  'low_power_mode_wake_trigger',
  'pcb_width',
  'pcb_layer',
  'pcb_class',
  'pcb_comments',

  'system_nvlink_speed',
  'system_nvlink_topology',
  'nvlink_bridge_mechanism',
  'nvlink_board_material',
  'nvlink_board_manufacturer',
  'io_switch_board_config',
  'baseboard_count',
  'gpu_tray_height',
  'baseboard_input_voltage',
  'mechanical_bottom_z_height',
  'mechanical_top_z_height',
  'pcie_speed',
  'pcie_width',
  'power_tgp_max',
  'power_tgp_rated',
  'clock',
  'clock.base_clock',
  'clock.boost_clock',
  'clock.vf_offset',
  'clock.oc_bin',
  'thermal_cooler_type',
  'thermal_acoustic_temperature_limit',
  'thermal_capacity',
  'thermal_cpu_capacity',
  'thermal_gpu_capacity',
  'thermal_cooler_topology',
  'thermal_cooler_design_source',
  'thermal_fan_type',
  'thermal_fan_connector',
  'thermal_fan_cooler_contact',
  'thermal_fan_count',
  'thermal_airflow_direction',
  'thermal_airflow_cfm',
  'thermal_airflow_inlet_temperature',
  'thermal_airflow_inlet_max_temperature',
  'thermal_cooler_vendor',
  'thermal_interface_material',
  'thermal_liquid_flow_direction',
  'thermal_liquid_flow_rate',
  'thermal_heatpipe',
  'thermal_reference_type',
  'thermal_stackup',
  'max_ambient_temperature',
  
  'max_ecu_ambient_temperature',
  'min_ecu_ambient_temperature',
  'soc_tdp',
  'ecu_tdp',
  'soc_subsystem_max',
  'ecu_max_power',
  'low_power_mode_support',
  'thermal_solution_running_sc',
  'thermal_solution_running_key_off',

  'tim_2_bond_line_thickness',
  'tim_3_bond_line_thickness',
  'thermal_average_pressure',
  'gpu_target_temperature_thermal_simulation',
  'pcb_thickness',
  'pcb_length',
  'pcb_height',
  'pcb_technology',
  'pcb_material',
  'pcb_stackup',
  'node_count_chassis',
  'tmp_rated',
  'tcp_rated',
  'tpm',
  'rtc',
  'management_board_details',
  'bmc_vendor_pn',
  'bmc_fw_vendor',
  'lan_on_motherboard',
  'bios_vendor',
  'chassis_dimensions',
  'psu',
  'psu_vendor_pn',
  'psu_input_voltage',
  'psu_wattage',
  'system_software',
  'pcb_layers',
  'nvme_hot_plug_support',
  'redundancy_configuration',
  'thermal_flow_rate',
  'mgx_compliant',

  // nested
  // 'features',
  'project_features.ms_hybrid_support',
  'project_features.discrete_mode',
  'project_features.aspm_support',
  'project_features.gc6_support',
  'project_features.gsync_dd_support',
  'project_features.gsync_nvsr_support',
  'project_features.gsync_hdr_support',
  'project_features.vapor_chamber',
  'project_features.heat_pipes',
  'project_features.2_way_sli',
  'project_features.3_way_sli',
  'project_features.thermal_led',
  'project_features.rtd3',
  'project_features.rtd3_gc6',
  'project_features.zero_power',
  'project_features.power_brake_b30',
  'project_features.smbpbi',
  'project_features.smbpbi_over_pcie',
  'project_features.programmable_edp_peak',
  'project_features.sr_iov',
  'project_features.rtx_studio',
  'project_features.dynamic_display_switching',
  'project_features.pcie_cable',
  'project_features.system_wake_on_wifi_support',
  'project_features.whispermode',
  'project_features.fanstop',
  'project_features.arm_uefi',
  'project_features.nvlink_bridge_support',
  'project_features.nvidia_certified',
  'project_features.virtual_gpu_certified',
  'project_features.voltage_monitoring',
  'project_features.in_system_test',
  'project_features.multi_instance_gpu',
  'project_features.video_decode',
  'project_features.optical_flow_accelerator',
  'project_features.nvaie_compatible',
  'project_features.workstation',
  'project_features.mobile_workstation',
  'project_features.datacenter',
  'project_features.enterprise_edge',
  'project_features.industrial_edge',
  'project_features.high_density_virtualization',
  'project_features.ngc_ready',
  'project_ssid',
  'project_ssid.value',
  'project_svid.value',
  'panel',
  'panel.size',
  'panel.height',
  'panel.width',
  'panel.refresh_rate',
  'panel.vendor_name',
  'panel.part_number',
  'cpu',
  'cpu.architecture',
  'cpu.classification',
  'cpu.brand',
  'cpu.cpu_core_count',
  'cpu.cpu_frequency',
  'baseboard_power_total',
  'baseboard_power_components',
  'baseboard_power_components.component',
  'baseboard_power_components.power',
  'display_connector',
  'display_connector.connector_type',
  'display_connector.link_type',
  'display_connector.connector_bracket',
  'display_connector.connector_source',
  'display_connector.connector_feature',
  'display_connector.connector_count',
  'power_monitor_ic.type',
  'power_monitor_ic.vendor',
  'power_monitor_ic.part_number',
  'power_monitor_ic.details',
  'input_connector',
  'memory',
  'memory.clock',
  'memory.part_type',
  'memory.density',
  'memory.config',
  'memory.vendor_name',
  'memory.part_number',
  'voltage_regulator',
  'voltage_regulator.vendor_name',
  'voltage_regulator.part_number',
  'voltage_regulator.part_type',
  'voltage_regulator.rail_type',
  'voltage_regulator.phase_count',
  'voltage_regulator.efficiency',
  'module_voltage_min',
  'module_voltage_max',
  'power_components',
  'power_components.rail_type',
  'power_components.component_type',
  'power_components.component_part',
  'power_components.component_details',
  'schedule.evt_start',
  'schedule.dvt_start',
  'schedule.pvt_start',
  'schedule.pilot_start',
  'schedule.mp_start',
  'schedule.sbios_lock',
  'schedule.whql_rc',
  'schedule.whql_production',
  'schedule.a_sample',
  'schedule.b_sample',
  'schedule.c_sample',
  'schedule.d_sample',
  'schedule.sop_start',
  'product_storage',
  'product_storage.count',
  'product_storage.details',
  'product_storage.storage_type',
  'nic',
  'nic.nic_vendor',
  'nic.nic_speed',
  'nic.nic_count',
  'nic.nic_protocol_type',
  'pcie_switch_retimer',
  'pcie_switch_retimer.vendor',
  'pcie_switch_retimer.part_number',
  'pcie_switch_retimer.count',
  'pcie_switch_retimer.details',
  'mission_profile',
  'mission_profile.vehicle_type',
  'mission_profile.service_life',
  'mission_profile.power_on_hours',
  'mission_profile.power_off_hours',
  'mission_profile.mileage',
  'mission_profile.power_on_off_cycles',
  'mission_profile.power_on',
  'mission_profile.power_off',
  'lc_voltage_regulator_device',
  'lc_voltage_regulator_device.device',
  'lc_voltage_regulator_device.vendor',
  'lc_voltage_regulator_device.part_number',
  'lc_voltage_regulator_device.output_voltage',
  'high_current_device',
  'high_current_device.device',
  'high_current_device.quantity',
  'high_current_device.vendor',
  'high_current_device.part_number',
  'high_current_device.output_voltage',

  'fsi_interface',
  'fsi_interface.device',
  'fsi_interface.initiator',
  'fsi_interface.interface_frequency',
  'fsi_interface.mode',
  'fsi_interface.vendor',
  'fsi_interface.part_number',

  'peripheral_interface_spi',
  'peripheral_interface_spi.port_number',
  'peripheral_interface_spi.initiator',
  'peripheral_interface_spi.spi_mode',
  'peripheral_interface_spi.interface_frequency',
  'peripheral_interface_spi.vendor_one',
  'peripheral_interface_spi.part_number_one',
  'peripheral_interface_spi.vendor_two',
  'peripheral_interface_spi.part_number_two',

  'fsync_signal',
  'fsync_signal.item',
  'fsync_signal.interface_frequency',
  'fsync_signal.vendor',
  'fsync_signal.part_number',

  'pwm',
  'pwm.port_number',
  'pwm.interface_frequency',
  'pwm.vendor',
  'pwm.part_number',

  'uart',
  'uart.port_number',
  'uart.interface_frequency',
  'uart.vendor',
  'uart.part_number',

  'memory_storage_device',
  'memory_storage_device.device',
  'memory_storage_device.memory_type',
  'memory_storage_device.bus_width',
  'memory_storage_device.max_frequency',
  'memory_storage_device.running_frequency',
  'memory_storage_device.vendor',
  'memory_storage_device.part_number',
  'memory_storage_device.max_temperature',
  'memory_storage_device.refresh_rate',

  'display_hdmi',
  'display_hdmi.mst_support',
  'display_hdmi.display_mode',
  'display_hdmi.serializer_vendor',
  'display_hdmi.serializer_part_number',
  'display_hdmi.serializer_bandwidth',
  'display_hdmi.header',
  'display_hdmi.dp_aux',
  'display_hdmi.initiator',
  'display_hdmi.inferface_frequency',
  'display_hdmi.device_vendor',
  'display_hdmi.part_number',

  'system_saftey_mcu',
  'system_saftey_mcu.device_vendor',
  'system_saftey_mcu.device_part_number',
  'system_saftey_mcu.interface',

  'system_ethernet_switch',
  'system_ethernet_switch.switch_number',
  'system_ethernet_switch.vendor',
  'system_ethernet_switch.part_number',
  'system_ethernet_switch.port',

  'thermal_interface_material_detail',
  'thermal_interface_material_detail.layer',
  'thermal_interface_material_detail.material_details',
  'thermal_interface_material_detail.bondline_thickness',
  'thermal_interface_material_detail.tim_thickness',
  'thermal_interface_material_detail.dispensing_pattern',
  'thermal_interface_material_detail.volume',

  'peripheral_interfaces_dap',
  'peripheral_interfaces_dap.port_number',
  'peripheral_interfaces_dap.initiator',
  'peripheral_interfaces_dap.dap_mode',
  'peripheral_interfaces_dap.dap_io',
  'peripheral_interfaces_dap.interface_frequency',
  'peripheral_interfaces_dap.vendor',
  'peripheral_interfaces_dap.part_number',

  'peripheral_interfaces_can',
  'peripheral_interfaces_can.port_number',
  'peripheral_interfaces_can.can_mode',
  'peripheral_interfaces_can.vendor',
  'peripheral_interfaces_can.part_number',

  'peripheral_interfaces_eth',
  'peripheral_interfaces_eth.item',
  'peripheral_interfaces_eth.port_number',
  'peripheral_interfaces_eth.speed',
  'peripheral_interfaces_eth.vendor',
  'peripheral_interfaces_eth.part_number',

  'peripheral_interfaces_usb_2',
  'peripheral_interfaces_usb_2.port_number',
  'peripheral_interfaces_usb_2.host_device',
  'peripheral_interfaces_usb_2.interface_frequency',
  'peripheral_interfaces_usb_2.connector',
  'peripheral_interfaces_usb_2.vendor',
  'peripheral_interfaces_usb_2.part_number',

  'peripheral_interfaces_usb_3',
  'peripheral_interfaces_usb_3.controller_number',
  'peripheral_interfaces_usb_3.host_device',
  'peripheral_interfaces_usb_3.interface_frequency',
  'peripheral_interfaces_usb_3.connector',
  'peripheral_interfaces_usb_3.vendor',
  'peripheral_interfaces_usb_3.part_number',

  'peripheral_interfaces_pcie',
  'peripheral_interfaces_pcie.controller_number',
  'peripheral_interfaces_pcie.pcie_mode',
  'peripheral_interfaces_pcie.number_lanes',
  'peripheral_interfaces_pcie.interface_frequency',
  'peripheral_interfaces_pcie.connector',
  'peripheral_interfaces_pcie.vendor',
  'peripheral_interfaces_pcie.part_number',

  'peripheral_interfaces_i_2_c',
  'peripheral_interfaces_i_2_c.port_number',
  'peripheral_interfaces_i_2_c.initiator',
  'peripheral_interfaces_i_2_c.interface_frequency',
  'peripheral_interfaces_i_2_c.device',
  'peripheral_interfaces_i_2_c.deviation',

  'camera_video_input',
  'camera_video_input.port_number',
  'camera_video_input.csi_group',
  'camera_video_input.csi_mode',
  'camera_video_input.number_of_lanes',
  'camera_video_input.deserializer_vendor',
  'camera_video_input.deserializer_part_number',
  'camera_video_input.deserializer_instance_number',
  'camera_video_input.estimated_total_bandwidth',

  'waterproof_rating',
  'boot_time_kpi',
  'ram_code',
  'boot_select',
  'boot_chain',

  'cpu_root_port.port_number',
  'cpu_root_port.port_configuration',
  'mgx_bay_type.bay_type',
  'mgx_bay_type.bay_count',
  
  'cpm',
  'cpm.nine_hundred_level_part_number',
  'cpm.cpm_project_priority_source',
  'cpm.cpm_product_sampled_source',
  'cpm.cpm_ready_for_review_source',
  'cpm.cpm_publish_to_web_source',
  'cpm.cpm_notes',
  'support_team',
  'support_team.customer_program_manager',
  'support_team.applications_engineering_manager',
  'support_team.account_applications_engineer',
  'support_team.field_applications_engineer',
  'support_team.applications_engineering_director',
  'support_team.product_applications_engineer',
  'support_team.product_manager',
  'support_team.customer_program_director',
  'support_team.observer',
]
export const ProductHierarchyEnum = Object.freeze({
  SEGMENT: {
    value: 0,
    label: 'Segment',
  },
  LINE: {
    value: 1,
    label: 'Line',
  },
  FAMILY: {
    value: 2,
    label: 'Family',
  },
  PLATFORM: {
    value: 3,
    label: 'Platform',
  },
  SKU: {
    value: 4,
    label: 'Product Sku',
  },
  BRAND: {
    value: 5,
    label: 'Brand',
  }
})


const listOrder = Object.freeze(
  listSortOrder.reduce((result, category, index) => ({
    ...result,
    [category]: index
  }), {})
)

const propertiesToExclude = [
  'clock.tgp'
]

const TRUNCATE = [{label: 'project_description', value: 40}]


const DefaultSearchFields = [
  // id and features
  2,3,4,5,
  // schedule
  6,7,8,9,10,11,12,13,214,215,216,217,218,
  // workflow
  66,
  // product hierarchy
  57,58,59,60,61,62,67,68,
  // partners
  63,64,65,
  // general
  69,70,71,72,73,74,75,76,77,78,79,80,
  // support team
  81,175,176,177,178,179,180,181,182,183,
  // project features
  184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,208,209,210,211
]

export {
  MODULE_NAME,
  ROW_THRESHOLD,
  MOUNT,
  UNMOUNT,
  ON_SUBMIT,
  ON_INPUT_CHANGE,
  ON_INPUT_FILTER_CHANGE,
  ON_FIELD_FILTER_CHANGE,
  ON_SELECT_FIELD,
  ON_REMOVE_FIELD,
  ON_SELECT_FILTER,
  ON_REMOVE_FILTER,
  ON_CLEAR_ALL,
  ON_CLEAR_FILTER,
  ON_HEADER_CLEAR_FILTER,
  ON_DIALOG_CLEAR,
  ON_SAVE_CLICK,
  ON_CANCEL_CLICK,
  ON_FIELD_BUTTON_CLICK,
  ON_SELECT_PUBLIC_FILTER,
  ON_REMOVE_PUBLIC_FILTER,
  ON_PINNED_CLICK,
  ON_ROW_SIZE_CHANGE,
  ON_SECTION_RENDER,
  ON_HEADER_CLICK,
  ON_COLUMN_REORDER,
  ON_MENU_HIDE,
  ON_HEADER_FILTER_CHANGE,
  ON_SORT_CHANGE,
  ON_APPLY_FILTER,
  ON_HEADER_FILTER_REMOVE,
  ON_INPUT_HEADER_VALUE_CHANGE,
  UPDATE_ROW_SIZE,
  UPDATE_MAX_ROW_SIZE,
  UPDATE_INPUT_FILTER_VALUE,
  UPDATE_INPUT_VALUE,
  INITIALIZE_FILTERS,
  INITIALIZE_HEADER_FILTERS,
  UPDATE_FILTERS,
  UPDATE_FROM,
  UPDATE_SIZE,
  UPDATE_TOTAL,
  UPDATE_SCROLL,
  UPDATE_ACTIVE,
  UPDATE_FIELD_FILTER_VALUE,
  UPDATE_PINNED,
  UPDATE_MENU_ACTIVE,
  UPDATE_CURRENT_INDEX,
  UPDATE_CUSTOM_COL_ORDER,
  UPDATE_LIST_ORDER,
  CLEAR_CUSTOM_COL_ORDER,
  UPDATE_INPUT_HEADER_LIST,
  CLEAR_FIELD_FILTERS,
  UPDATE_FIELD_FILTERS,
  UPDATE_HEADER_FILTER,
  REMOVE_HEADER_FILTER,
  COPY_QUICK_FILTERS,
  CLEAR_TEMP_QUICK_FILTERS,
  UPDATE_TEMP_QUICK_FILTERS,
  REMOVE_TEMP_QUICK_FILTERS,
  COPY_TEMP_QUICK_FILTERS,
  UPDATE_SORT_BY,
  UPDATE_SORT_TYPE,
  UPDATE_SORT_INDEX,
  CLEAR_TEMP_FIELD_FILTERS,
  UPDATE_TEMP_FIELD_FILTERS,
  REMOVE_TEMP_FIELD_FILTERS,
  COPY_TEMP_FIELD_FILTERS,
  REMOVE_FILTERS,
  CLEAR_FILTERS,
  CLEAR_QUICK_FILTERS,
  CLEAR_HEADER_FILTERS,
  FETCH_PROJECT_LIST,
  FETCH_PROJECT_LIST_START,
  FETCH_PROJECT_LIST_SUCCESS,
  FETCH_PROJECT_LIST_ERROR,
  POST_FETCH_PROJECT_LIST_SUCCESS,
  FETCH_PROJECT_FILTERS,
  FETCH_PROJECT_FILTERS_START,
  FETCH_PROJECT_FILTERS_SUCCESS,
  FETCH_PROJECT_FILTERS_ERROR,
  FROM_SIZE,
  listOrder,
  rowSize,
  propertiesToExclude,
  VIEW_ALL,

  UPDATE_DISPLAY_FILTER,
  CLEAR_DISPLAY_FILTERS,
  REMOVE_DISPLAY_FILTER,
  COPY_DISPLAY_FILTERS,
  ON_SELECT_SEARCH_FILTER,
  ON_REMOVE_SEARCH_FILTER,

  UPDATE_QUICK_FILTER,
  REMOVE_QUICK_FILTER,

  UPDATE_SEARCH_FILTERS_SOURCE,
  CLEAR_SEARCH_FILTERS,

  DELETE_CUSTOM_VIEW,
  ADD_CUSTOM_VIEW,
  ENABLE_CUSTOM_VIEW,
  DISABLE_CUSTOM_VIEW,

  UPDATE_SEARCH_FILTERS,

  ON_SELECT_PRODUCT_FILTER,
  UPDATE_PRODUCT_HIERARCHY_SOURCE,
  UPDATE_PRODUCT_HIERARCHY_FILTER,
  AUTO_UPDATE_PRODUCT_HIERARCHY_SOURCE,
  TOGGLE_COLLAPSE,
  RESET_PRODUCT_HIERARCHY_FILTER,
  CLEAR,
  SAVE_VIEW,
  DefaultSearchFields,
  UPDATE_PUBLIC_CUSTOM_VIEWS,
  UPDATE_CUSTOM_VIEW,
  EDIT_CUSTOM_VIEW,
  UPDATE_VIEW_NAME,
  TOGGLE_PUBLIC_VIEW,
  UPDATE_TEMP_CUSTOM_VIEW,
  UPDATE_TEMP_PRODUCT_FILTERS,
  UPDATE_TEMP_SEARCH_FILTERS,
  UPDATE_TEMP_SELECTED_SEARCH_FILTERS,
  UPDATE_TEMP_SELECTED_PRODUCT_FILTERS,

  SELECT_TEMP_SEARCH_FILTER,
  REMOVE_TEMP_SEARCH_FILTER,
  SELECT_TEMP_PRODUCT_FILTER,
  REMOVE_TEMP_PRODUCT_FILTER,
  CLEAR_VIEW_LABEL,
  SET_DEFAULT_VIEW,
  TOGGLE_SEARCH_SECTION_COLLAPSE,
  CLEAR_SEARCH_SECTION_COLLAPSES,
  REMOVE_CUSTOM_VIEW,
  DESELECT_ALL_SEARCH_FILTERS,
  SELECT_ALL_SEARCH_FILTERS,
  CLEAR_SEARCH_FILTERS_UI,
  COPY_HEADER_FILTERS,
  TRUNCATE,
  EXPAND_ALL_SEARCH_FILTERS,
  COLLAPSE_ALL_SEARCH_FILTERS,
  SELECT_ALL_SEARCH_SECTION,
  UPDATE_SELECTED_SEARCH_FILTERS,
  ADD_TO_SEARCH_FILTERS,
  COPY_PRODUCT_HIERARCHY
}
